import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {ConfigService} from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class ShardHandlerService {


  constructor(private apiService: ApiService,
              private config: ConfigService,
  ) {
    // Do an initial call for this shard
  }

  /**
   * Endpoint usually returns:
   * {data: {name: string, alias: string}}
   */
  public get() {
    // Get the current shard and details of this shard
    return this.apiService.get('/v1/shard/');
  }

  public getAlias() {
    let alias = this.config.get('forcedAlias');
    if (!alias) {
      alias = 'default';
    }

    const host = window.location.hostname;
    const splitted = host.split('.');

    const isLocalHost = host === 'localhost' || host === '127.0.0.1' || host === '::1';
    const isIpAddress = /^\d{1,3}(\.\d{1,3}){3}$/.test(host);

    if (!this.config.get('forcedAlias') && !isLocalHost && !isIpAddress && splitted.length > 0) {
      alias = splitted[0];
    }
    return alias;
  }
}
